import React, {Component} from 'react';
import {Provider} from 'react-redux';
import {Chrome, uiActions} from './chrome';
import {sessionActions} from './user';
import {categoryActions} from './category';
import {createBrowserHistory} from 'history';
import createB2MeStore from './createB2MeStore';
import checkForUpdates from './checkForUpdates';
import parseQueryString from './parseQueryString';

const query = parseQueryString(window.location.search);

const history = createBrowserHistory();

history.listen((location, action) => {
	setTimeout(() => {
		const el = document.querySelector('.scroll-anchor');

		window.scrollTo({
			top: el ? el.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 48 : 0,
			behavior: 'smooth'
		});
	}, 100);
});

export const store = createB2MeStore(history);

class App extends Component {
	render() {
		return (
			<Provider store={store}>
				<Chrome history={history} />
			</Provider>
		);
	}
}

store.dispatch(sessionActions.checkLoginStatus());

// Get lookups (is this the most efficient place to put it?)
setTimeout(() => store.dispatch(categoryActions.retrieveCategories()), 1000);

// Check every 6 hours for updates. Not too frequently to avoid battery drainage on 3G/4G devices.
const UPDATE_CHECK_FREQUENCY_MS = 6 * 60 * 60 * 1000;
setInterval(checkForUpdates(store.dispatch), UPDATE_CHECK_FREQUENCY_MS);
setTimeout(checkForUpdates(store.dispatch), 500); // Cache initial html 500ms after initial load

window.addEventListener(
	'resize',
	() => store.dispatch(uiActions.uiResized(window.innerWidth)),
	false
);
store.dispatch(uiActions.uiResized(window.innerWidth));

if (query.signup_community) {
	store.dispatch(sessionActions.sessionSignupCommunity(query.signup_community));
	store.dispatch(uiActions.uiModal('signup'));
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js